import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicRoutingModule } from '@impactdk/ngx-routing-utils';
import { TranslateModule } from '@ngx-translate/core';
import { PageComponent } from './page.component';

@NgModule({
    declarations: [PageComponent],
    imports: [
        CommonModule,
        DynamicRoutingModule,
        TranslateModule.forChild(),
        RouterModule,
    ],
    exports: [PageComponent],
})
export class PageModule {}
